import ModuleManager from "../module_manager";
import Module from "./module_base";
import MVVMBase from './mvvm_base';
import UTween from '../../../uiextend/UTween';
import UserDataManager from "../../../manager/user_manager";
import ModelData from "../../../pacakge/public/model_data";
const { ccclass, property } = cc._decorator;

@ccclass
export default class ViewBase extends MVVMBase {

    public  _moduleBase : Module<any, any>

    public onButtonClickEventFunctions

    private _cacheComponent : Array<any> = []

    //缓动数据缓存播放
    private _cacheTweenData : Array<UTween>

    onShow(arg0?: any) {
        this.registUserDataEvent()
        this.onSelfCurrencyDataUpdate && this.onSelfCurrencyDataUpdate(UserDataManager._selfCurrencyData)
        if(ModelData.instance.roleData && ModelData.instance.roleData.id){
            let userData = UserDataManager._userDatas[ModelData.instance.roleData.id.toString()]
            userData && this.onUserDataUpdate && this.onUserDataUpdate(userData)
        }   
    }

    onLoad() {

    }

    _show(intentData?: any) {
        this.onShow(intentData)
    }

    on_destroy(): any{}
    
    destroyView(releaseResources) {
        this.isDestroyed = true
        this.on_destroy()
        this._baseDestroy(releaseResources)
        this.unscheduleAllCallbacks()
    }

    onInit() {

    }
    
    public cacheComponent(name : string, component : cc.Component) {
        this._cacheComponent.push(component)
    }

    public cacheTweenDatas(component : UTween) {
        this._cacheTweenData = this._cacheTweenData ? this._cacheTweenData : []
        this._cacheTweenData.push(component)
    }

    public tweenTo(tweenName ?: string, inverted ?: boolean, callback ?) {
        if (this._cacheTweenData) {
            this._cacheTweenData.forEach(element => {
                element.to(tweenName, inverted, callback)
            });
        }
    }
    public tweenToPoint(tweenName : string, inverted ?: boolean, callback ?) {
        if (this._cacheTweenData) {
            this._cacheTweenData.forEach(element => {
                element.toPoint(tweenName, inverted, callback)
            });
        }
    }

    showNetPrompt(show: boolean) {
        if (show) {
            ModuleManager.instance.showModuleName("NetPrompt")
        } else {
            ModuleManager.instance.hideModule("NetPrompt")
        }
    }

    buttonClick(node: cc.Node, customEventData) {
        // cc.log(node.name)
        this._moduleBase._ButtonClick(node, customEventData)
    }

    toggleClick(node: cc.Toggle) {
        // cc.log(node.name)
        this._moduleBase._ToggleClick(node)
    }

    changeLanguage() {
        this._cacheComponent.forEach(element => {
            if (element.onChangeLanguage) {
                element.onChangeLanguage()
            }
        });
    }


    changeHeadActon(headImage:cc.Sprite, callback:Function){
        let heightY = headImage.node.getContentSize().height;
        let diffY = 0.3
        
        let moveAction1 = cc.moveTo(0.3, new cc.Vec2(0, heightY)).easing(cc.easeExponentialOut());
        let moveAction2 = cc.moveTo(0.4, new cc.Vec2(0, -(heightY * diffY))).easing(cc.easeSineIn());
        let moveAction3 = cc.moveTo(0.15, new cc.Vec2(0, -(heightY * diffY))).easing(cc.easeSineIn());
        let moveAction4 = cc.moveTo(0.6, new cc.Vec2(0, 0)).easing(cc.easeExponentialOut());
        headImage.node.runAction(cc.sequence(moveAction1, cc.callFunc(callback),  moveAction2, moveAction3, moveAction4
        ));
    }

    private registUserDataEvent(){
        let self = this
        self.onSelfCurrencyDataUpdate && self.eventBind('refresh_user_money', self.onSelfCurrencyDataUpdate)
        self.onUserDataUpdate && self.eventBind('refresh_user_data', self.onUserDataUpdate)
    }
}
